import * as React from "react";

function SvgAlert(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={24} height={20} {...props}>
        <g data-name="Group 11779">
          <path data-name="Polygon 6" d="M12 0l12 20H0z" fill="#e15241" />
          <g data-name="Group 11777" fill="#fff">
            <path
              data-name="Path 43363"
              d="M11.837 14.126a.759.759 0 00.756-.757v-5.91a.758.758 0 00-.756-.756.758.758 0 00-.755.756v5.91a.759.759 0 00.755.757z"
            />
            <path data-name="Path 43364" d="M11.838 14.919a.836.836 0 10.837.837.838.838 0 00-.837-.837z" />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgAlert;
